<template lang="pug">
v-dialog(v-model="value", scrollable, persistent, max-width=640)
    v-card
        v-card-title {{ receiptTitle }}
        v-card-text.mt-4
            v-form#receipt-form(v-model="formValid", ref="receiptform")
                v-img.mb-4(
                    v-if="receipt.imageUrl",
                    :src="receipt.imageUrl",
                    width="308",
                    height="160"
                )
                v-file-input(
                    v-else-if="receiptId == null",
                    v-model="receipt.image",
                    :placeholder="$t('Receipts.__UploadReceipt')",
                    accept="image/*",
                    prepend-icon="mdi-camera",
                    outlined,
                    dense                )
                .field-label 
                    span {{ $t('Receipts.__Merchant') }}
                    span.required *
                .text.mb-4(v-if="isView") {{ receipt.merchantName }}
                v-text-field(
                    v-else,
                    v-model="receipt.merchantName",
                    solo,
                    dense,
                    outlined,
                    required,
                    :rules="[rules.required]"
                )

                .field-label 
                    span {{ $t('Receipts.__Date') }}
                    span.required *
                .text.mb-4(v-if="isView") {{ receipt.date }}
                .date-select(v-else)
                    v-menu(
                        v-model="dateMenu",
                        offset-y,
                        :close-on-content-click="false",
                        :nudge-right="40",
                        transition="scale-transition",
                        min-width="290px"
                    )
                        template(v-slot:activator="{ on }")
                            v-text-field(
                                v-model="receipt.date",
                                clearable,
                                solo,
                                dense,
                                outlined,
                                readonly,
                                append-icon="event",
                                v-on="on",
                                :placeholder="$t('Placeholder.__Date')",
                                :rules="[rules.required]"
                            )
                        v-date-picker(
                            v-model="receipt.date",
                            @input="dateMenu = false"
                            :locale="$store.getters['account/language']() == 'tw'? 'zn-tw': ''"
                        )

                .field-label 
                    span {{ $t('Receipts.__Memo') }}
                .text.mb-4(v-if="isView") {{ receipt.memo }}
                v-textarea(
                    v-else,
                    v-model="receipt.memo",
                    solo,
                    outlined,
                    height="80"
                )

                .field-label 
                    span {{ $t('Receipts.__PaymentAccount') }}
                    span.required *
                .text.mb-4(v-if="isView && receipt.paymentAccount") {{ getAccountTranslatedName(receipt.paymentAccount.name) }}
                AccountSelector(
                    v-else,
                    v-model="receipt.paymentAccountId",
                    :rules="[rules.required]"
                )
                //- v-select(v-else v-model="receipt.accounting" solo dense outlined :items="accountings" placeholder="選擇會計科目")

                .field-label 
                    span {{ $t('Receipts.__ExpenseAccount') }}
                    span.required *
                .text.mb-4(v-if="isView && receipt.entryAccount") {{ getAccountTranslatedName(receipt.entryAccount.name) }}
                //- v-select(v-else v-model="receipt.category" solo dense outlined :items="categories" placeholder="選擇類別")
                AccountSelector(
                    v-else,
                    v-model="receipt.entryAccountId",
                    :rules="[rules.required]"
                )

                .field-label 
                    span {{ $t('Receipts.__BeforeTaxAmount') }}
                    span.required *
                .text.mb-4(v-if="isView") {{ receipt.subtotal }}
                v-text-field(
                    v-else,
                    v-model.number="receipt.subtotal",
                    solo,
                    dense,
                    outlined,
                    required,
                    :rules="[rules.required]",
                    @input="updateAmount"
                )

                .field-label 
                    span {{ $t('Receipts.__Tax') }}
                .taxes-select(v-if="!isView")
                    TaxesSelector(
                        v-model="receipt.taxes",
                        @input="taxesUpdated"
                    )
                .text.mb-2(v-for="tax in receipt.taxes") 
                    span {{ tax.name }}
                    span.ml-2 {{ currency.symbol }} {{ tax.amount }}

                //- .tax-amount(v-for="tax in receipt.taxes")
                //-     | {{tax}}

                //- v-btn.pa-0.mb-4(text color="primary" @click="")
                //-     v-icon(left small color="primary") add
                //-     | 新增稅額
                .field-label.mt-4 
                    span {{ $t('Receipts.__AfterTaxAmount') }}
                .text {{ currency.symbol }} {{ receipt.total }}

        v-card-actions.justify-center.mb-6
            v-btn.mr-6(
                rounded,
                dark,
                @click="$emit('input', false)",
                color="lightGray",
                width="112"
            ) {{ $t('ActionOption.__Close') }}
            v-btn(
                v-if="!isView",
                rounded,
                dark,
                @click="saveReceipt",
                color="primary",
                width="112"
            ) {{ $t('ActionOption.__Save') }}
</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"
import * as currencyHelper from "@/utils/currencies.js"
import * as accountHelper from "@/utils/accountHelper"

export default {
  mixins: [currencyHelper.mixin, accountHelper.mixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    receiptId: {
      type: String,
      default: "0"
    },
    isView: {
      type: Boolean,
      default: false
    },
    confirmAction: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      show: false,
      formValid: false,
      rules: textfieldUtils.rules,
      dateMenu: false,
      currency: {},
      categories: [],
      accountings: [],
      receipt: {
        subtotal: 0,
        total: 0,
        taxes: []
        // entryAccountId: null,
        // paymentAccountId: null
      }
    }
  },
  watch: {
    // receiptId(val) {
    //     this.$refs.receiptform.resetValidation()
    //     if (val != null) {
    //         this.getReceipt()
    //     } else {
    //         this.receipt = {
    //             subtotal: 0,
    //             total: 0,
    //             taxes: []
    //         }
    //         // this.$refs.receiptform.resetValidation()
    //     }
    // },
    isView(val) {},
    value(val) {
      // this.show = val
      if (this.$refs.receiptform != undefined) {
        this.$refs.receiptform.resetValidation()
      }
      if (val) {
        if (this.receiptId != null) {
          this.getReceipt()
        } else {
          this.receipt = {
            subtotal: 0,
            total: 0,
            taxes: []
          }
          // this.$refs.receiptform.resetValidation()
        }
      }
    }
  },
  methods: {
    getReceipt() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("receipts/getReceipt", this.receiptId)
        .then(
          function(response) {
            this.receipt = response.data
            this.receipt.total = response.data.total
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    saveReceipt() {
      this.$refs.receiptform.validate()
      if (this.formValid) {
        if (this.receiptId == null) {
          this.createReceipt()
        } else {
          this.updateReceipt()
        }
      }
    },
    createReceipt() {
      this.receipt.currencyCode = this.currency.code
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("receipts/createReceipt", this.receipt)
        .then(
          function(response) {
            this.confirmAction()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyCreated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    updateReceipt() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("receipts/updateReceipt", this.receipt)
        .then(
          function(response) {
            this.confirmAction()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyUpdated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    taxesUpdated() {
      this.receipt.taxIds = this.receipt.taxes.map(tax => tax.id)
      this.updateAmount()
    },

    updateAmount() {
      var subtotal = this.receipt.subtotal
      var total = subtotal
      for (var tax of this.receipt.taxes) {
        var taxAmount = (subtotal * tax.rate) / 100
        tax.amount = taxAmount
        total += taxAmount
      }

      this.receipt.total = total
    }
  },
  // updated() {
  //     if (this.$refs.receiptform != undefined && this.show) {
  //         this.$refs.receiptform.resetValidation()
  //         this.show = false
  //     }
  // },
  computed: {
    receiptTitle() {
      if (this.receiptId == null) {
        return this.$t("Receipts.__AddReceipt")
      } else if (this.isView) {
        return this.$t("Receipts.__ReceiptDetail")
      } else {
        return this.$t("Receipts.__EditReceipt")
      }
    }
  },
  mounted() {
    this.biz = this.$store.getters["bizes/biz"]()
    this.currency = this.getCurrency(this.biz.currencyCode)
  },

  created() {}
}
</script>
<style lang="scss" scoped>
#receipt-form {
  .text {
    font-size: 16px;
    color: #505356;
  }
}
</style>
